import "./App.css";
import PublicRoute from "./routers/PublicRoute";
import "./Variables.css";

function App() {
  return (
    <>
      <PublicRoute />
    </>
  );
}

export default App;
